// extracted by extract-css-chunks-webpack-plugin
module.exports = {"title":"title-1CoGtdeh","list":"list-2nR8xnDf","red":"red-2EkO7XYi","black":"black-2lhXEjmD"};